import { Field, Form, Formik } from "formik";
import React, { useEffect, useRef, useState } from "react";
import KibabMenu from "../../../../assets/icons/kibab-menu";
import Select from "react-select";
import { useDispatch } from "react-redux";
import {
  addItemGroupAction,
  deleteItemGroupAction,
  itemGroupTableListAction,
  uomDropDownAction,
  uomDropDownActionnew,
  updateItemGroupAction,
} from "../../../../redux/actions/settings-action";
import errorToast from "../../../helper-components/error-toast";
import DeleteIcon from "../../../../assets/icons/delete-icon";
import successToast from "../../../helper-components/success-toast";
import AddButton from "../../../buttons/button";
import LoadingSpinner from "../../../helper-components/loading-spinner";
import SelectField from "../../../forms/select-field";

const customStyles = {
  control: (provided, state) => ({
    ...provided,
    border: "none",
  }),
  indicatorSeparator: (provided) => ({
    ...provided,
    display: "none",
  }),
  menuPortal: (provided) => ({
    ...provided,
    zIndex: 9999, // High z-index to appear above other elements
  }),
  menu: (provided) => ({
    ...provided,
    zIndex: 9999, // Also set z-index for non-portal menus
  }),
};

const ItemGroupTable = ({ searchValue, reload }) => {
  const tableHeading = ["Group Code", "Group Name", "Default UOM", "Action"];
  const [disableArrayFields, setDisableArrayFields] = useState(false);
  const [disableNewFields, setDisableNewFields] = useState(false);
  const [selectedDOtIndex, setSelectedDOtIndex] = useState(null);
  const [uomLists, setUomLists] = useState([]);
  const [initialData, setGroupListData] = useState([]);
  const [loading, setLoading] = useState(false);

  const dispatch = useDispatch();

  const handleFieldChange = (index, field, value, setFieldValue) => {
    setFieldValue(`${index}.${field}`, value);
  };

  useEffect(() => {
    dispatch(
      itemGroupTableListAction({}, onFetchItemTypeSuccess, onFetchItemTypeError)
    );
    setLoading(true);
  }, []);

  useEffect(() => {
    dispatch(
      itemGroupTableListAction(
        { searchValue },
        onFetchItemTypeSuccess,
        onFetchItemTypeError
      )
    );
    setLoading(true);
  }, [searchValue, reload]);

  const reloadData = () => {
    dispatch(
      itemGroupTableListAction({}, onFetchItemTypeSuccess, onFetchItemTypeError)
    );
    setLoading(true);
  };

  const onFetchItemTypeSuccess = (data) => {
    setGroupListData(data?.data?.itemGroupList);
    setLoading(false);
  };

  const onFetchItemTypeError = (data) => {
    setGroupListData([]);
    errorToast(data?.data?.message);

    setLoading(false);
  };

  const initialValues = {
    data: initialData,
    newLine: {
      code: "",
      name: "",
      default_uom_id: "",
    },
  };

  const onSubmit = (values, { setSubmitting }) => {
    const changedObjects = [];
    let newLineObject = null;

    // Collect changed array data
    initialData.forEach((item, index) => {
      if (JSON.stringify(values.data[index]) !== JSON.stringify(item)) {
        const { id, code, name, default_uom_id } = values.data[index];
        const pushingObj = {
          id,
          code,
          name,
          default_uom_id,
        };
        changedObjects.push(pushingObj);
      }
    });

    // Collect new line data if it is altered
    if (
      JSON.stringify(values.newLine) !== JSON.stringify(initialValues.newLine)
    ) {
      newLineObject = values.newLine;
    }

    if (newLineObject !== null) {
      console.log("newLineObject", newLineObject);
      if (
        newLineObject.code === "" ||
        newLineObject.name === "" ||
        newLineObject.default_uom_id === ""
      ) {
        errorToast("Please fill all the fields in the new line.");
        setSubmitting(false);
        return;
      }
      const dispatchingObj = {
        code: newLineObject.code,
        name: newLineObject.name,
        default_uom_id: newLineObject.default_uom_id,
      };
      dispatch(
        addItemGroupAction(dispatchingObj, onCreateSuccess, onCreateError)
      );
    }

    if (changedObjects.length > 0) {
      dispatch(
        updateItemGroupAction(
          { updatingData: changedObjects },
          onUpdateSuccess,
          onUpdateError
        )
      );
    }

    setSubmitting(false);
  };

  const onCreateSuccess = (data) => {
    reloadData();
    setDisableArrayFields(false);
    setDisableNewFields(false);
    successToast(data?.message);
  };
  const onCreateError = (data) => {
    setDisableArrayFields(false);
    setDisableNewFields(false);
    errorToast(data?.data?.message);
  };

  const onUpdateSuccess = (data) => {
    reloadData();
    setDisableArrayFields(false);
    setDisableNewFields(false);
    successToast(data?.message);
  };
  const onUpdateError = (data) => {
    setDisableArrayFields(false);
    setDisableNewFields(false);
    errorToast(data?.data?.message);
  };

  const componentRef = useRef(null);

  const handleClickOutside = (event) => {
    if (componentRef.current && !componentRef.current.contains(event.target)) {
      setSelectedDOtIndex(null);
    }
  };

  useEffect(() => {
    dispatch(uomDropDownActionnew({}, onSuccessUsers, onErrorUsers));
  }, [dispatch]);

  const onSuccessUsers = (data) => {
    setUomLists(
      data?.data?.map((item) => ({
        label: item?.name,
        value: item?.uom_id,
      }))
    );
  };

  const onErrorUsers = (data) => {};

  const onClickDelete = (id) => {
    dispatch(deleteItemGroupAction({ id }, onDeletSuccess, onError));
  };
  const onDeletSuccess = (data) => {
    reloadData();
    setDisableArrayFields(false);
    setDisableNewFields(false);
    successToast(data?.message);
  };

  const onError = (data) => {
    errorToast(data?.data?.message);

    selectedDOtIndex(null);
  };

  return (
    <Formik
      enableReinitialize={true}
      initialValues={initialValues}
      onSubmit={onSubmit}
    >
      {({ values, setFieldValue, dirty, handleSubmit }) => (
        <Form className="pt-1">
          <div
            onClick={handleClickOutside}
            className="flex flex-col justify-between"
            style={{ height: "70vh" }}
          >
            {loading ? (
              <LoadingSpinner />
            ) : (
              <div className=" mb-auto rounded-xl table-container border border-gray-200 overflow-visible">
                <table className=" w-full ">
                  <thead className="sticky top-0 bg-[var(--create-table-header-bg)] z-[10]">
                    <tr className="relative h-[50px]">
                      {tableHeading.map((heading, index) => (
                        <th
                          className={`text-start px-[8px] whitespace-nowrap text-[var(--create-table-header-fg)] text-[length:var(--create-table-header-fs)] font-[var(--create-table-header-fw)]`}
                          key={heading}
                        >
                          {heading}
                        </th>
                      ))}
                    </tr>
                  </thead>
                  <tbody style={{ position: "relative" }}>
                    {values.data.map((item, index) => (
                      <tr key={index}>
                        <td
                          className={`tab-cell text-sm fw_400 text-secondary`}
                        >
                          <Field
                            name={`data[${index}].code`}
                            placeholder="Code"
                            disabled={disableArrayFields}
                            onChange={(e) => {
                              const rawValue = e.target.value;
                              const cleanedValue = rawValue.replace(
                                /[^a-zA-Z0-9]/g,
                                ""
                              );

                              if (rawValue !== cleanedValue) {
                                // 🚨 Invalid character found
                                errorToast(
                                  "Only letters and numbers are allowed"
                                );
                              }
                              handleFieldChange(
                                `data[${index}]`,
                                "code",
                                cleanedValue,
                                setFieldValue
                              );
                            }}
                            maxLength={15}
                            className="border-0 focus:outline-none focus:ring focus:ring-blue-500 rounded px-1 py-2 w-28"
                          />
                        </td>
                        <td
                          className={`tab-cell text-sm fw_400 text-secondary`}
                        >
                          <Field
                            name={`data[${index}].name`}
                            placeholder="Name"
                            disabled={disableArrayFields}
                            onChange={(e) => {
                              let value = e.target.value;
                              const originalValue = value;

                              // 1. Remove special characters (only letters, numbers, spaces allowed)
                              value = value.replace(/[^a-zA-Z0-9 ]/g, "");

                              // Show error toast if invalid characters were entered
                              if (originalValue !== value) {
                                errorToast(
                                  "Only letters, numbers, and spaces are allowed"
                                );
                              }

                              // 2. Prevent leading space
                              value = value.replace(/^\s+/, "");

                              // 3. Prevent consecutive spaces and show error toast
                              if (value !== value.replace(/\s+/g, " ")) {
                                errorToast(
                                  "Consecutive spaces are not allowed"
                                );
                              }
                              value = value.replace(/\s+/g, " ");

                              handleFieldChange(
                                `data[${index}]`,
                                "name",
                                value,
                                setFieldValue
                              );
                            }}
                            maxLength={20}
                            className="border-0 focus:outline-none focus:ring focus:ring-blue-500 rounded py-2"
                          />
                        </td>
                        <td
                          className={`tab-cell text-sm fw_400 text-secondary`}
                        >
                          {/* <Select
                            options={uomLists}
                            name={`data[${index}].default_uom_id`}
                            placeholder="Select a default UOM"
                            value={uomLists.find(
                              (uom) => uom.value === item.default_uom_id
                            )}
                            onChange={(e) => {
                              const value = e.value.replace(
                                /[^a-zA-Z0-9]/g,
                                ""
                              );
                              handleFieldChange(
                                `data[${index}]`,
                                "default_uom_id",
                                value,
                                setFieldValue
                              );
                            }}
                            className="w-52"
                            styles={customStyles}
                          /> */}
                          <SelectField
                            defaultValue={uomLists.find(
                              (uom) => uom.value === item.default_uom_id
                            )}
                            labelClass={`text-[var(--alert-management-label-color)] text-[length:var(--alert-management-label-fs)] font-[var(--alert-management-sub-title-fw)] w-full`}
                            label=""
                            general_color="true"
                            borderclass="border border-[var(--pay-met-input-border)] rounded-lg"
                            isContainer={true}
                            containerClass={` w-full flex flex-col gap-2`}
                            parentClass={`w-[70%] flex flex-col gap-2`}
                            errMsgContainerClass="hidden"
                            options={uomLists}
                            name={`data[${index}].default_uom_id`}
                            placeholder="Select a default UOM"
                            isSearchable={true}
                            isRequired={false}
                            // value={uomLists.find(
                            //   (uom) => uom.value === item.default_uom_id
                            // )}
                            handleSelected={(e) => {
                              const value = e.value.replace(
                                /[^a-zA-Z0-9 ]/g,
                                ""
                              );
                              handleFieldChange(
                                "newLine",
                                "code",
                                value,
                                setFieldValue
                              );
                            }}
                          />
                        </td>
                        <td className="tab-cell text-sm fw_400 text-secondary w-2/12">
                          <div className="flex items-center">
                            <button
                              type="button"
                              onClick={() => onClickDelete(item?.id)}
                            >
                              <DeleteIcon />
                            </button>
                          </div>
                        </td>
                      </tr>
                    ))}
                    <tr>
                      <td className={`tab-cell text-sm fw_400 text-secondary`}>
                        <Field
                          name="newLine.code"
                          placeholder="Code"
                          disabled={disableNewFields}
                          onChange={(e) => {
                            const rawValue = e.target.value;
                            const cleanedValue = rawValue.replace(
                              /[^a-zA-Z0-9]/g,
                              ""
                            );

                            if (rawValue !== cleanedValue) {
                              // 🚨 Invalid character found
                              errorToast(
                                "Only letters and numbers are allowed"
                              );
                            }
                            handleFieldChange(
                              `newLine`,
                              "code",
                              cleanedValue,
                              setFieldValue
                            );
                          }}
                          maxLength={20}
                          className="border-0 focus:outline-none focus:ring focus:ring-blue-500 rounded py-2 w-28"
                          autoFocus={searchValue ? false : true}
                        />
                      </td>
                      <td className={`tab-cell text-sm fw_400 text-secondary`}>
                        <Field
                          name="newLine.name"
                          placeholder="Name"
                          disabled={disableNewFields}
                          onChange={(e) => {
                            let value = e.target.value;
                            const originalValue = value;

                            // 1. Remove special characters (only letters, numbers, spaces allowed)
                            value = value.replace(/[^a-zA-Z0-9 ]/g, "");

                            // Show error toast if invalid characters were entered
                            if (originalValue !== value) {
                              errorToast(
                                "Only letters, numbers, and spaces are allowed"
                              );
                            }

                            // 2. Prevent leading space
                            value = value.replace(/^\s+/, "");

                            // 3. Prevent consecutive spaces and show error toast
                            if (value !== value.replace(/\s+/g, " ")) {
                              errorToast("Consecutive spaces are not allowed");
                            }
                            value = value.replace(/\s+/g, " ");

                            handleFieldChange(
                              "newLine",
                              "name",
                              value,
                              setFieldValue
                            );
                          }}
                          maxLength={15}
                          className="border-0 focus:outline-none focus:ring focus:ring-blue-500 rounded py-2"
                        />
                      </td>
                      <td className={`tab-cell text-sm fw_400 text-secondary`}>
                        {/* <Select
                          options={uomLists}
                          name="newLine.default_uom_id"
                          placeholder="Select a default UOM "
                          value={values.newLine.default_uom_id}
                          onChange={(e) =>
                            handleFieldChange(
                              "newLine",
                              "default_uom_id",
                              e,
                              setFieldValue
                            )
                          }
                          className="w-52"
                          styles={customStyles}
                        /> */}
                        <SelectField
                          defaultValue={uomLists.find(
                            (uom) => uom.value === values.newLine.default_uom_id
                          )}
                          labelClass={`text-[var(--alert-management-label-color)] text-[length:var(--alert-management-label-fs)] font-[var(--alert-management-sub-title-fw)] w-full`}
                          label=""
                          general_color="true"
                          borderclass="border border-[var(--pay-met-input-border)] rounded-lg"
                          isContainer={true}
                          containerClass={` w-full flex flex-col gap-2`}
                          parentClass={`w-[70%] flex flex-col gap-2`}
                          errMsgContainerClass="hidden"
                          options={uomLists}
                          name="newLine.default_uom_id"
                          placeholder="Select a default UOM"
                          isSearchable={true}
                          isRequired={false}
                        />
                      </td>
                      <td
                        className={`tab-cell text-sm fw_400 text-secondary`}
                      ></td>
                    </tr>
                  </tbody>
                </table>
              </div>
            )}

            <div className="mt-auto flex gap-3 items-center justify-end w-full h-[4rem]">
              <AddButton
                onclkFn={handleSubmit}
                prefixIcon={false}
                text="Save"
                type="submit"
                className="
    flex items-center px-3 py-2  whitespace-nowrap rounded-md gap-[8px]
    bg-[var(--primary-button-bg-color)] cursor-pointer
    text-[var(--primary-button-fg-color)]
    border border-[var(--primary-button-bg-color)]
    hover:bg-[var(--primary-button-hover-color)]
    text-[length:var(--primary-button-create-fs)] 
    font-[var(--primary-button-font-weight)]
    "
              />
            </div>
          </div>
        </Form>
      )}
    </Formik>
  );
};

export default ItemGroupTable;
